<template>
  <div class="wl-container">
    <div class="wl-content-container">

      <!-- 搜索框 -->
      <div class="wl-search-bar">
        <div class="wl-left">
          <el-input :placeholder="$t('KPMG_USER_MANAGEMENT_PLACE_HOLDER')"
                    v-model="searchContent"
                    maxlength="100"
                    @keyup.enter.native="searchUser"
                    clearable
                    @clear="searchUser"
                    class="input-with-select">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchUser" style="cursor: pointer" />
          </el-input>
        </div>

        <div class="wl-right">

          <select-ad ref="selectAdd"
                     class="select-ad-cls"
                     :api="selectFromAD"
                     :filter="adFilter"
                     :onAdd="onAddAccount"></select-ad>
          <el-button
                  class="wl-green svg-btn"
                  @click="batchOperate.showCheck = true"
                  :disabled="batchOperate.showCheck"
          >
            <img src="@/assets/img/icon-batchdeletion.svg" width="100%" class="btn-icon" />
            {{$t('patch_delete_user')}}
          </el-button>
          <el-button @click="download"
                     class="wl-green"
                     icon="el-icon-download">{{$t('COMMON_DOWNLOAD_TEMP')}}</el-button>

          <el-upload class="template-uploader"
                     action="url"
                     :http-request="uploadFiles"
                     :show-file-list="false"
                     :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload">
            <el-button class="wl-green svg-btn"><img src="@/assets/img/icon-import.svg" class="btn-icon" width="100%"/>{{$t('COMMON_IMPORT')}}</el-button>
          </el-upload>
        </div>
      </div>

      <!-- 表格 -->

      <div :class="['table-container-wrapper', batchOperate.showCheck? 'show-table-bottom-operate': '']">
        <el-table height="100%"
                  class="wl-user-table"
                  v-loading="loading"
                  @selection-change="onTableCheckChange"
                  :data="data"
                  border
                  stripe>
          <el-table-column
                  type="selection"
                  width="55"
                  v-if="batchOperate.showCheck"
          />
          <el-table-column type="index"
                           width="70"></el-table-column>

          <el-table-column prop="staffNo"
                           :label="$t('TABLE_HEADER_EMAIL_StaffNo')"></el-table-column>

          <el-table-column prop="userName"
                           :label="$t('TABLE_HEADER_EMAIL_StaffName')"></el-table-column>

          <el-table-column prop="profitCenter"
                           :label="$t('TABLE_HEADER_EMAIL_ProfitCenter')"></el-table-column>

          <el-table-column prop="position"
                           :min-width="120"
                           :label="$t('TABLE_HEADER_EMAIL_Position')"></el-table-column>

          <el-table-column prop="email"
                           :label="$t('TABLE_HEADER_EMAIL_Email')"></el-table-column>

          <el-table-column prop="action"
                           width="120"
                           align="center"
                           :label="$t('TABLE_HEADER_Action')">
            <template slot-scope="scope">
              <i class="el-icon-delete wl-icon-delete"
                 @click="onDeleteAccount(scope.row)"></i>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div v-if='batchOperate.showCheck' class="wl-btn-container">
        <el-button @click="batchOperate.showCheck=false" class="cancel-btn">
          {{$t('btn_cancel')}}
        </el-button>
        <el-button @click="batchDel" class="wl-green" v-if="batchOperate.showCheck" :disabled="batchOperate.data.length <= 0" :loading="batchOperate.loading">
          {{$t('patch_delete_user')}}
        </el-button>
      </div>
      <!-- 分页 -->
      <el-pagination class="wl-pagination"
                     :current-page="pagination.pageNum"
                     :page-size="pagination.pageSize"
                     @current-change="onCurrentPageChange"
                     @size-change="onSizeChange"
                     :page-sizes="[10, 50, 100]"
                     layout="prev, pager, next,sizes, total"
                     :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>
<script>
import SelectAd from '@/components/common/selectAd'
import API from '@/api'
import { deleteConfirm, loading, addConfirm, isIE, UserInput } from '@/utils'
import {mapGetters} from 'vuex'

export default {
    name: 'user',
    data() {
        return {
            data: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            searchContent: '',
            fileParams: new FormData(),
            batchOperate: {
              showCheck: false,
              data: [],
              loading: false
            }
        }
    },
    mounted() {
        this.getStaffList()
    },
    methods: {
        onTableCheckChange(e) {
          this.batchOperate.data = e
        },
        batchDel() {
          this.$confirm(this.$t('sel_msgList_delete_sure'), {
            confirmButtonText: this.$t('btn_confirm'),
            cancelButtonText: this.$t('btn_cancel'),
            type: 'warning',
            cancelButtonClass: 'cancel-btn',
            confirmButtonClass: 'wl-green'
          }).then(() => {
            this.batchOperate.loading = true
            const params = {
              userIds: this.batchOperate.data.map(v => `${v.id}`),
              siteId: this.getSite.siteId
            }
            API.system.batchDeleteUser(params).then(res => {
              if (res.code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.pagination.pageNum = 1
                this.getStaffList()
                this.batchOperate = {
                  showCheck: false,
                  data: [],
                  loading: false
                }
              } else {
                this.$message.error(this.$t(res.code))
              }
            })
            .catch(e => {
              console.error(e);
              this.$message.error(this.$t('SYS_USER_003'))
            })
            .finally(() => {
              this.batchOperate.loading = false
            })
          })
        },
        handleAvatarSuccess(res, file) {

        },
        beforeAvatarUpload(file) {
            const isExcel =
                file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 5

            if (!isExcel) {
                this.$message.error(this.$t('import_file_type_error'))
            }
            if (!isLt2M) {
                this.$message.error(this.$t('import_file_size_error'))
            }
            return isExcel && isLt2M
        },
        uploadFiles(item) {
            this.fileParams = new FormData()
            this.fileParams.append('file', item.file)
            this.fileParams.append('siteId', this.getSite.siteId)
            this.upload()
        },
        async upload() {
            let service = loading()
            try {
                service.upload()
                const { data, code, errDetails } = await API.system.importKPMGUserTemplate(this.fileParams)
                if (code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {
                service.close()
            }
        },
        onAddAccount(list) {
            addConfirm().then(() => this.addUser(list))
        },
        onDeleteAccount(row) {
            deleteConfirm().then(() => this.deleteUser(row.id))
        },
        searchUser: _.debounce(
            function() {
                if (this.searchContent && !UserInput.reg1.test(this.searchContent)) {
                    this.$message.error(this.$t('ILLEGAL_USER_INPUT_02'))
                    return
                }
                this.onCurrentPageChange(1)
            },
            500,
            { leading: true }
        ),
        onSizeChange(size) {
          this.pagination.pageSize = size
          this.pagination.pageNum = 1
          this.getStaffList()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getStaffList()
        },
        selectFromAD: params => API.system.adList(params),
        adFilter: v =>
            Object.assign({}, v, {
                label: v.userName + '  (' + v.profitCenter + ')',
                value: v.userAccount
            }),
        getStaffList: async function() {
            try {
                this.loading = true
                const { code, data, errDetails } = await API.system.queryUserList({
                    ...this.pagination,
                    searchContent: this.searchContent
                })
                if (code == '1') {
                    this.data = data.records
                    this.pagination.total = data.total

                    this.loading = false
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {
                this.loading = false
            }
        },
        deleteUser: async function(id) {
            try {
                const { code, data, errDetails } = await API.system.deleteUser({
                    id,
                    siteId: this.getSite.siteId
                })
                if (code == '1') {
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {}
        },
        addUser: async function(idList) {
            try {
                const { code, data, errDetails } = await API.system.addUser({siteId: this.getSite.siteId, ...idList[0]})
                if (code == '1') {
                    this.$refs.selectAdd.clear()
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {}
        },
        async download() {
            let service = loading()
            try {
                service.download()
                const res = await API.system.downloadMatterFiles()

                if (/application\/json/.test(res.type)) {
                    let reader = new FileReader()
                    reader.onload = e => {
                        if (e.target.readyState === 2) {
                            let resJson = {}
                            resJson = JSON.parse(e.target.result)
                            this.$message.error({duration: 5000, message: this.$t(resJson.code)})
                        }
                    }
                    reader.readAsText(res)
                }else 
                if (/application\/octet-stream/.test(res.type)) {
                    let blob = new Blob([res])
                    if (isIE()) {
                        navigator.msSaveBlob(blob, 'KPMGUserTemplate.xlsx')
                    } else {
                        let url = window.URL.createObjectURL(blob)
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', 'KPMGUserTemplate.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    }
                }
            }
            catch(e) {}
            finally {
                service.close()
            }
        }
    },
    components: {
        SelectAd
    },
    computed: {
      ...mapGetters('common', {
        getSite: 'getSite',
      })
    }
}
</script>

<style scoped>
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}

.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
    border-radius: 8px;
}

.wl-search-bar {
    height: 45PX;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.wl-left,
.wl-right {
    display: flex;
    align-items: center;
}
.wl-left{
  justify-content: flex-start;
}
.wl-right{
  justify-content: flex-end;
}

.input-with-select {
    width: 300px;
}
.select-ad-cls{
  margin-right: 10px;
}
.template-uploader {
    margin-left: 10px;
}
.table-container-wrapper{
  height: calc(100% - 48px - 45PX);
}
.table-container-wrapper.show-table-bottom-operate{
  height: calc(100% - 98px - 45PX);
}
.wl-btn-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 50px;
}
</style>
